import { render } from "./CancellationRefundPolicy.vue?vue&type=template&id=4910ed1e&scoped=true"
import script from "./CancellationRefundPolicy.vue?vue&type=script&lang=js"
export * from "./CancellationRefundPolicy.vue?vue&type=script&lang=js"

import "./CancellationRefundPolicy.vue?vue&type=style&index=0&id=4910ed1e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4910ed1e"]])

export default __exports__